import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const getFiduciaryClients = async () => {
  const url = '/fiduciaryclients';
  return request.get(url);
};

export const getProductsOfFiduciaryClient = async ({ selectedClient }) => {
  const url = `/fiduciaryclients/${selectedClient}/products`;
  return request.get(url);
};

export const getLineupProductsOfFiduciaryClient = async ({ selectedClient }) => {
  const url = `/fiduciaryclients/${selectedClient}/lineups-products`;
  return request.get(url);
};

export const getReplacementsDataOfFiduciaryClient = async ({ selectedClient }) => {
  // fiduciaryclients and fiduciary-clients are two diff endpoints
  const url = `/fiduciary-clients/${selectedClient}/replacements`;
  return request.get(url);
};

export const getInProgressReplacementsDataOfFiduciaryClient = async ({ selectedClient }) => {
  // fiduciaryclients and fiduciary-clients are two diff endpoints
  const url = `/fiduciary-clients/${selectedClient}/inprogress-replacements`;
  return request.get(url);
};

export const getActiveReplacementsDataOfFiduciaryClient = async ({ selectedClient }) => {
  // fiduciaryclients and fiduciary-clients are two diff endpoints
  const url = `/fiduciary-clients/${selectedClient}/active-replacements`;
  return request.get(url);
};
